module.exports = __webpack_public_path__ + "img/knus_gallery0.f632bf6b.jpg";